













import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStatics, AcgnStaticsStaff, AcgnStaticsMenu, AcgnGroupEdit } from '@/components';

@Component({
  components: {
    AcgnStatics,
    AcgnStaticsStaff,
    AcgnStaticsMenu,
    AcgnGroupEdit
  },
  mixins: [RenderMenuMixin]
})

/**
 * 创作方-项目统计
 */
export default class StatisticComic extends Vue {

  private comicId: number = 0; // 漫画id

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId} isNor={true}></acgn-statics-menu>
    );
  }

  private created() {
    this.comicId = parseInt(this.$route.params.id, 0);
  }
}
